import React from "react";

interface Props {
  color?: string;
}

const CctvCameraIcon: React.FC<Props> = ({ color = "black" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 18 11"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "inline-block", color }}
    >
      <path
        d="M12.6244 5.37649e-05C13.8383 0.623404 14.5053 1.46467 14.7355 2.38214L7.9574 4.55099C6.97844 4.38913 5.76509 4.25364 4.39896 4.85264C3.3603 4.06757 2.29841 3.68223 0.812909 3.49719L12.6244 5.37649e-05ZM14.811 2.78167C14.9063 3.62746 14.6529 4.53437 14.1089 5.39144L6.56757 7.65994C6.96776 7.13179 7.20587 6.39922 7.18022 5.59312C7.1719 5.33166 7.13978 5.08168 7.08095 4.84264C7.38225 4.87096 7.67324 4.91289 7.95155 4.95939C7.98301 4.96381 8.0155 4.96057 8.04548 4.95016L14.811 2.78172ZM0.000218656 3.81823C1.25849 3.91028 2.18706 4.09149 3.0046 4.46368C2.90871 4.73848 2.84291 5.03719 2.81918 5.34878L1.63225 5.55613C0.917959 5.05431 0.276149 4.55441 0.000218656 3.81823ZM3.33023 4.62917C3.64414 4.79768 3.94855 4.99559 4.25405 5.23406C4.31178 5.27952 4.39535 5.28946 4.46214 5.25883C5.27154 4.88113 6.01435 4.79319 6.69696 4.8172C6.77165 5.06351 6.81995 5.32646 6.82879 5.6043C6.87073 6.922 6.08592 8.00811 5.07205 8.04038C4.05818 8.07264 3.20589 7.03864 3.16396 5.72093C3.15149 5.32919 3.21258 4.96018 3.33023 4.62917ZM12.7658 6.21922L13.2312 7.61743C12.9391 7.60883 12.6148 7.69732 12.3962 7.83241L11.9381 6.46536L12.7658 6.21919ZM13.112 8.01688C13.6689 7.99916 14.1302 8.43198 14.148 8.98873C14.1657 9.54551 13.7328 10.0068 13.1758 10.0245C12.6189 10.0422 12.1576 9.60942 12.1398 9.05264C12.1198 8.447 12.5085 8.03257 13.112 8.01688ZM14.4739 8.57016L17.7496 8.46591L17.7752 9.26896L14.5057 9.37301C14.5391 9.2456 14.554 9.11398 14.5496 8.97595C14.5451 8.83504 14.5169 8.69741 14.4739 8.57016Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CctvCameraIcon;